import React, { useCallback, useContext, useEffect, useRef} from 'react'
import styles from "../css/ViewNote.module.css"
import { colors_dict, light_colors } from '../../../data/colorsDict'
import useFormattedTime from '../../../hooks/useFormattedTime'
import NotFound from '../../Error/js/NotFound';
import CrashError from '../../Error/js/CrashError';
import { useDispatch, useSelector } from 'react-redux';
import { viewNote } from '../../../actions/noteActions';
import { PageContext } from '../../board/js/Notes';

const ViewNote = () => {
    const mounted = useRef(true)
    const note = useSelector((state)=>state.noteState.selectedNote)
    const crashError = useSelector((state)=>state.noteState.crashError)
    const notFound = useSelector((state)=>state.noteState.notFound)
    const dispatch = useDispatch()
    const creationDate = useFormattedTime(note?.createdAt)
    const updateDate = useFormattedTime(note?.updatedAt)
    const container = useRef(null)
    const [pageModals,setPageModals] = useContext(PageContext)
    const { view: id} = pageModals

    const closeModal = useCallback(() => {
        setPageModals((prevState)=>{
            let copy = {...prevState}
            copy.view = null
            return copy
        })
    },[setPageModals])

    useEffect(()=>{
        if (mounted.current){
            mounted.current = false
            dispatch(viewNote(id))
        }
        const handleClick = (e) => {
            if (!container.current?.contains(e.target) && note){
                closeModal()
            }
        }
        window.addEventListener("mousedown",handleClick)
        return() => {
            window.removeEventListener("mousedown",handleClick)
        }
    },[id,dispatch,note,closeModal])

    const handleMenu = (attr) => {
        dispatch({type: "MODAL_RESET"})
        setPageModals({...pageModals,view:null,[attr]:id})
    }

    return (
    notFound.state ? 
        <NotFound
            msg = {notFound.text}
            closeMenu = {()=>closeModal()}
        /> :
    crashError.state ?
        <CrashError
            closeMenu = {()=>closeModal()}
            msg = {crashError.text}
            retry = {()=> dispatch(viewNote(id))}
        />  : 
    (note ? <div className = {styles.wrapper} ref = {container} style={{ '--color-light': light_colors[note.color], '--color-default': colors_dict[note.color] }}>

        <div data-testid = {`view-modal-${id}`} className={styles.modal}>
            <div data-testid = "note-color-bar" className={styles.accent} style = {{ backgroundColor: colors_dict[note.color]}}></div>
            <div className={styles.header}>
                <div className={styles.headerLeft}>
                <div className={styles.headerTop}>
                    <div className={styles.lastUpdated}>Last updated: {updateDate}</div>
                </div>
                <div className={styles.tags}>
                    {note.tags.map((tag)=>(
                        <span
                            data-testid = {`tag-${tag._id}`}
                            key = {tag._id}
                            className={styles.tag}
                            style={{background:light_colors[note.color],color:colors_dict[note.color]}}
                        >
                            {tag.name}
                        </span>

                    ))}
                </div>
                <div className={styles.title}>{note.title}</div>
                <div className={styles.date}>{creationDate}</div>
                </div>
                <button data-testid = "close-btn" className={styles.close} onClick = {()=>closeModal()}>✕</button>
            </div>

            <div className={styles.body}>
                <div className={styles.colorBar} style = {{ backgroundColor: colors_dict[note.color]}}></div>
                <div 
                    data-testid = "note-content"
                    className={styles.content}
                    dangerouslySetInnerHTML={{ __html: note.content }}
                /> 
            </div>

            <div className={styles.footer}>
                <div className={styles.footerActions}>
                    <button type = "button" className={styles.actionBtn} onClick = {()=>handleMenu("delete")}>🗑 Delete</button>
                </div>
                <button type = "button" className={styles.editBtn} style={{ boxShadow: `0 4px 14px var(--note-${note.color.toLowerCase()}-shadow)`}} onClick = {()=>handleMenu("edit")}><span>✏️</span> Edit Note</button>
            </div>
        </div>
    </div> : <div className = {styles.wrapper}>
        <div className ={`${styles.modal} ${styles.loading}`} >
            <div className={styles.accent}></div>
            <div className={styles.header}>
                <div className={styles.headerLeft}>
                <div className={styles.headerTop}>
                    <div className={styles.updateDateLoading}></div>
                </div>
                <div className={styles.tags}>
                    {[...Array(3).keys()].map((tag,index)=>(
                        <span
                            key = {index}
                            className={styles.loadingTag}
                        >
                        </span>

                    ))}
                </div>
                <div className={styles.loadingTitle}></div>
                <div className={styles.loadingDate}></div>
                </div>
                <button className={styles.close} onClick = {()=>closeModal()}>✕</button>
            </div>
            <div className={styles.body}>
                <div className={styles.colorBar}></div>
                <div className={styles.content}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>

            <div className={styles.footer}>
                <div className={styles.footerActions}>
                    <div className = {styles.loadingDeleteBtn}></div>
                </div>
                <div className = {styles.loadingEditBtn}></div>
            </div>
        </div>
    </div>)
  )
}

export default ViewNote